import React from 'react'

const objectivesContext = React.createContext({
    objectivesPartner: [],
    setObjectivesPartner: () => {},
})

export default objectivesContext;